import { render, staticRenderFns } from "./hiLanguage.vue?vue&type=template&id=27c505f3&"
import script from "./hiLanguage.vue?vue&type=script&lang=js&"
export * from "./hiLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports